var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-98a33c44-df7a-4c9f-a0ec-12c2ac63c0b3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd",
    d: "M21.99,18.08c-.55,0-1-.45-1-1v-2.15c0-.55.45-1,1-1s1,.45,1,1v2.15c0,.55-.45,1-1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd",
    d: "M10.01,18.08c-.55,0-1-.45-1-1v-2.15c0-.55.45-1,1-1s1,.45,1,1v2.15c0,.55-.45,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd",
    d: "M19.02,20.27c-.55,0-1-.45-1-1v-6.55c0-.55.45-1,1-1s1,.45,1,1v6.55c0,.55-.45,1-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd",
    d: "M16.02,19.07c-.55,0-1-.45-1-1v-4.14c0-.55.45-1,1-1s1,.45,1,1v4.14c0,.55-.45,1-1,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bba16b3-1967-4e16-b396-0bbe121c01bd",
    d: "M13.03,22.99c-.55,0-1-.45-1-1v-11.99c0-.55.45-1,1-1s1,.45,1,1v11.99c0,.55-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSaid);
export default __webpack_public_path__ + "static/media/UserSaid.df132c5caba587d20b28d04fa5d4fcda.svg";
export { ForwardRef as ReactComponent };